function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $3d04e619ba156511$exports = {};

$parcel$defineInteropFlag($3d04e619ba156511$exports);

$parcel$export($3d04e619ba156511$exports, "calculate", () => $3d04e619ba156511$export$2409b27812872cc9);
$parcel$export($3d04e619ba156511$exports, "calculate1", () => $3d04e619ba156511$export$d8bda67a4265dbc7);
$parcel$export($3d04e619ba156511$exports, "sayHello", () => $3d04e619ba156511$export$2c6a96c059a06e7c);
$parcel$export($3d04e619ba156511$exports, "calculate2", () => $3d04e619ba156511$export$84d55f414cef6039);
$parcel$export($3d04e619ba156511$exports, "calculate3", () => $3d04e619ba156511$export$d919f1ddbc17d71f);
$parcel$export($3d04e619ba156511$exports, "myFavouriteColor", () => $3d04e619ba156511$export$c15ce5fbc6216bd4);
$parcel$export($3d04e619ba156511$exports, "default", () => $3d04e619ba156511$export$2e2bcd8739ae039);
function $3d04e619ba156511$export$2409b27812872cc9(myNumber) {
    return myNumber * 7;
}
function $3d04e619ba156511$export$d8bda67a4265dbc7(myNumber) {
    myNumber = myNumber + 3;
    console.log(myNumber);
    return myNumber * 7;
}
const $3d04e619ba156511$var$result = $3d04e619ba156511$export$d8bda67a4265dbc7(2);
console.log($3d04e619ba156511$var$result);
function $3d04e619ba156511$export$2c6a96c059a06e7c() {
    console.log("hello");
}
// (fat) arrow funtion
const $3d04e619ba156511$export$84d55f414cef6039 = (myNumber)=>{
    myNumber = myNumber + 3;
    console.log(myNumber);
    return myNumber * 7;
};
const $3d04e619ba156511$export$d919f1ddbc17d71f = (myNumber)=>(myNumber + 4) * 7;
const $3d04e619ba156511$export$c15ce5fbc6216bd4 = "hotpink";
const $3d04e619ba156511$var$tax = "23%";
var $3d04e619ba156511$export$2e2bcd8739ae039 = $3d04e619ba156511$var$tax;


function $b8f57191916382d3$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(obj);
}


function $377d1ce359384586$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $bce2d00733a79246$export$2e2bcd8739ae039(argument) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $b8f57191916382d3$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $6eb366e006a8b659$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}




function $9445ecc5e7cfb647$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $f8bd67cac91ee19b$var$MILLISECONDS_IN_DAY = 86400000;
function $f8bd67cac91ee19b$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var startOfDayLeft = (0, $9445ecc5e7cfb647$export$2e2bcd8739ae039)(dirtyDateLeft);
    var startOfDayRight = (0, $9445ecc5e7cfb647$export$2e2bcd8739ae039)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $6eb366e006a8b659$export$2e2bcd8739ae039)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $6eb366e006a8b659$export$2e2bcd8739ae039)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $f8bd67cac91ee19b$var$MILLISECONDS_IN_DAY);
}



// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $5e650688c0910592$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $5e650688c0910592$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = $5e650688c0910592$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $f8bd67cac91ee19b$export$2e2bcd8739ae039)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($5e650688c0910592$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


const $74debe69a9d675f7$var$substractNumbers = (a, b)=>{
    let c = a - b;
    console.log(`${a} - ${b} = ${c}`);
    return c;
};
var $74debe69a9d675f7$export$2e2bcd8739ae039 = $74debe69a9d675f7$var$substractNumbers;


const $54b47fc030b7b21e$var$firstName = "Paweł Haraf";
const $54b47fc030b7b21e$var$age = 37;
console.log(`Cześć :) Nazywam się ${$54b47fc030b7b21e$var$firstName} i mam ${$54b47fc030b7b21e$var$age} lat`);
// moduł 3 DOMowe przedszkole
const $54b47fc030b7b21e$var$header = document.querySelector(".page-header__heading--js");
console.log($54b47fc030b7b21e$var$header);
console.log($54b47fc030b7b21e$var$header.innerHTML);
$54b47fc030b7b21e$var$header.innerHTML = `Cześć :) Nazywam się <span class="special">${$54b47fc030b7b21e$var$firstName}</span> i mam ${$54b47fc030b7b21e$var$age} lat. To jest tekst nagłówka zmienionego poprzez JS:`;
console.log($54b47fc030b7b21e$var$header.style);
$54b47fc030b7b21e$var$header.style.color = "red";
// zadanie domowe z trzeciego tygodnia
const $54b47fc030b7b21e$var$content = document.querySelector(".article__content--js");
console.log($54b47fc030b7b21e$var$content);
$54b47fc030b7b21e$var$content.innerHTML = `Zawartość paragrafu była pusta. Została uzupełniona poprzez javaScript. Jest to możliwe dzięki temu, że JS ma dostęp do różnych elementów w HTMLu czy CSSie poprzez DOM. Dzięki temu strony mogą być bardziej interaktywne.`;
// 05.06 javaScript: funkcje
// function calculate(myNumber) {
// 	return myNumber * 7
// }
console.log((0, $3d04e619ba156511$export$2409b27812872cc9)(2));
// function calculate1(myNumber) {
// 	myNumber = myNumber + 3
// 	console.log(myNumber)
// 	return myNumber * 7
// }
(0, $3d04e619ba156511$export$d8bda67a4265dbc7)(1);
// const result = calculate1(2)
// console.log(result)
// function sayHello() {
// 	console.log('hello')
// }
(0, $3d04e619ba156511$export$2c6a96c059a06e7c)();
// (fat) arrow funtion
// const calculate2 = myNumber => {
// 	myNumber = myNumber + 3
// 	console.log(myNumber)
// 	return myNumber * 7
// }
(0, $3d04e619ba156511$export$84d55f414cef6039)(1);
// const calculate3 = myNumber => (myNumber + 4) * 7
console.log((0, $3d04e619ba156511$export$d919f1ddbc17d71f)(2));
// 05.07 javaScript: obiekt
const $54b47fc030b7b21e$var$deathStar = {
    diameter: 120000,
    fire: (target)=>{
        console.log(`${target} destroyed 💣`);
    },
    isOperating: true,
    levels: 357,
    name: "Death Star",
    population: 10000,
    comander: {
        name: "darth vader"
    }
};
console.log($54b47fc030b7b21e$var$deathStar);
console.log($54b47fc030b7b21e$var$deathStar.name);
$54b47fc030b7b21e$var$deathStar.fire("alderan");
$54b47fc030b7b21e$var$deathStar.fire("scarif");
console.log($54b47fc030b7b21e$var$deathStar["levels"]);
console.log($54b47fc030b7b21e$var$deathStar.comander.name);
// 05.08 JS: Immutability w obiektach
const $54b47fc030b7b21e$var$humanOne = {
    name: "Maciek",
    age: 32,
    address: {
        street: "Warszawska",
        city: "Białystok"
    }
};
const $54b47fc030b7b21e$var$humanTwo = {
    name: "Paweł",
    age: 32,
    address: $54b47fc030b7b21e$var$humanOne.address
};
console.log($54b47fc030b7b21e$var$humanOne);
console.log($54b47fc030b7b21e$var$humanTwo);
$54b47fc030b7b21e$var$humanTwo.age = 35;
$54b47fc030b7b21e$var$humanOne.address.street = "Lipowa";
console.log($54b47fc030b7b21e$var$humanOne);
console.log($54b47fc030b7b21e$var$humanTwo);
const $54b47fc030b7b21e$var$humanThree = $54b47fc030b7b21e$var$humanOne;
console.log($54b47fc030b7b21e$var$humanOne);
console.log($54b47fc030b7b21e$var$humanThree);
$54b47fc030b7b21e$var$humanThree.age = 35;
console.log($54b47fc030b7b21e$var$humanOne);
console.log($54b47fc030b7b21e$var$humanThree);
// zadanie domowe z tygodnia V
function $54b47fc030b7b21e$var$hello(age, firstName) {
    console.log(`Witam Was wszystkich na mojej stronie. Nazywam się ${firstName} i mam ${age} lat.`);
}
$54b47fc030b7b21e$var$hello($54b47fc030b7b21e$var$age, $54b47fc030b7b21e$var$firstName);
// 06.02 Logika w JS
let $54b47fc030b7b21e$var$myNumber1;
if ($54b47fc030b7b21e$var$myNumber1 === 4) console.log("my number to 4");
else if ($54b47fc030b7b21e$var$myNumber1 === 8) console.log("my number to 8");
else console.log("nie wiem ile wynosi my number");
switch($54b47fc030b7b21e$var$myNumber1){
    case 4:
        console.log("my number to 4");
        break;
    case 8:
        console.log("my number to 8");
        break;
    default:
        console.log("nie wiem ile wynosisz");
}
$54b47fc030b7b21e$var$myNumber1 > 4 ? console.log("większe niż 4") : console.log("mniejsze lub r\xf3wne od 4");
// 06.12 eventy - click
const $54b47fc030b7b21e$var$button = document.querySelector(".page-header__button--js");
$54b47fc030b7b21e$var$button.addEventListener("click", (e)=>{
    console.log("click, click");
    const header = document.querySelector(".page-header__heading--js");
    header.innerHTML = "Zmieniony tekst nagł\xf3wka przez javaScript!!!";
    document.documentElement.style.setProperty("--backgroundColor", "tomato");
});
// 06.13 🍔 menu
const $54b47fc030b7b21e$var$hamburger = document.querySelector(".hamburger--js");
$54b47fc030b7b21e$var$hamburger.addEventListener("click", ()=>{
    console.log("\uD83C\uDF54");
    const navigation = document.querySelector(".navigation--js");
    navigation.classList.toggle("navigation--open");
});
// 08.03 javaScript: import/export
console.log((0, $3d04e619ba156511$export$c15ce5fbc6216bd4));
console.log((0, $3d04e619ba156511$export$2e2bcd8739ae039));
console.log($3d04e619ba156511$exports);
console.log($3d04e619ba156511$exports.calculate(2));
console.log($3d04e619ba156511$exports.myFavouriteColor);
// 08.04 javaScript: import/export modułów
const $54b47fc030b7b21e$var$resultDays = (0, $5e650688c0910592$export$2e2bcd8739ae039)(new Date(2024, 4, 19, 21, 0), new Date());
console.log(`Do moich urodzin pozostało ${$54b47fc030b7b21e$var$resultDays} dni.`);
// 08.10 Zadanie domowe
console.log((0, $74debe69a9d675f7$export$2e2bcd8739ae039)(10, 5));
console.log(`Różnica między 10, a 5 to: ${(0, $74debe69a9d675f7$export$2e2bcd8739ae039)(10, 5)}`);


//# sourceMappingURL=index.aca0da4d.js.map
